import {h, Fragment} from "preact"
import { useAppState, useActions } from '@nosto/preact';
import Facet from './Facet';
import RangeFacet from './RangeFacet';
import { useProductFilters } from '@nosto/preact'
import { useEffect, useState, useMemo, useLayoutEffect } from 'preact/hooks';
import Sorting from '../components/Sorting'
import ProductTypeFilter from './ProductTypeFilter';
import { PRODUCT_TYPE_FILTERS } from '../config'
import { render } from "preact";

const TYPE = "Type"
const PRODUCT_TYPE_FILTER = ["One-time", "Subscription"];
const PRODUCT_COUNT_SELECTOR = "#collection-product-count";
const CONTACT_BTN_SELECTION = "#collection-contact-button"
const COLLECTION_FILTER_SELECTOR = "#collection-sortby-filter";

const ContactButton = ({ handleOnClickContactSeller }) => <button
    id="collection-contact-seller-btn"
    type='button'
    class="btn-primary flex items-center gap-2 m-auto border border-gray-300 rounded-md text-black hover:bg-gray-50 text-sm py-2 px-4 text-nowrap"
    data-app-contact-seller-open
    onClick={handleOnClickContactSeller}
>
    <svg width="20" version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
        <g transform="translate(0,-952.36218)">
            <path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;"
                d="m 16,973.36218 c -4.4385,0 -7.9999999,3.7333 -7.9999999,8.2188 l 0,41.53122 c 0,4.4854 3.5614999,8.25 7.9999999,8.25 l 68,0 c 4.4387,0 8,-3.7646 8,-8.25 l 0,-41.53122 c 0,-4.4855 -3.5613,-8.2188 -8,-8.2188 l -68,0 z m 0,4 68,0 c 0.5867,0 1.1544,0.1432 1.6563,0.375 L 52.5938,1008.331 c -1.5276,1.4131 -3.5634,1.4133 -5.0938,0 L 14.375,977.73718 c 0.4955,-0.2245 1.0481,-0.375 1.625,-0.375 z m -3.9374,3.6875 23.4687,21.68752 -23.0313,22.4062 c -0.3039,-0.6003 -0.5,-1.2807 -0.5,-2.0312 l 0,-41.53122 c 0,-0.1838 0.043,-0.3552 0.063,-0.5313 z m 75.875,0.031 c 0.018,0.1662 0.062,0.3269 0.062,0.5 l 0,41.53122 c 0,0.7348 -0.1765,1.4084 -0.4687,2 l -22.9687,-22.4062 23.375,-21.62502 z m -26.2813,24.31242 22.4687,21.9688 c -0.042,0 -0.083,0 -0.125,0 l -68,0 c -0.032,0 -0.062,7e-4 -0.094,0 l 22.5625,-21.9375 6.3125,5.8437 c 2.9675,2.7408 7.5644,2.7446 10.5313,0 l 6.3437,-5.875 z"
                fill="#000000" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible" />
        </g>
    </svg>
    Contact Seller
</button>

export default ({ isCategorySelected, handleOnClickContactSeller }) => {
    const { filters, removeAll } = useProductFilters()
    const { response: { query, products, products: { facets } } = {} } = useAppState();
    const [modal, setModal] = useState(false)
    const { updateSearch } = useActions();
    const [selectedFilters, setSelectedFilters] = useState(filters || [])
    const [isApplyFilterBtnDisabled, setIsApplyFilterBtnDisabled] = useState(true);
    const filteredFacets = useMemo(() => facets?.filter(({ name }) => name !== TYPE), [facets])
    const previousAppliedTypeFilter = useMemo(() => selectedFilters.find(({ name }) => name === TYPE)?.value || "");

    const productTypeFilter = facets.find(({ name }) => name === TYPE);
    const updatedTypeFilters = productTypeFilter?.data.filter(({ value }) => PRODUCT_TYPE_FILTER.includes(value));

    const showProductFilterOnCollection = !query && window.cj.nosto.productTypeFilterEnabled && productTypeFilter
    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled
    const formClass = shouldShowNewSearch ? 'hidden lg:flex flex-wrap items-center gap-4' : 'filter-form';

    const productCountEl = document.querySelector(PRODUCT_COUNT_SELECTOR);
    const contactButtonEl = document.querySelector(CONTACT_BTN_SELECTION);
    const sortByEl = document.querySelector(COLLECTION_FILTER_SELECTOR);

    const areFilterValuesEqual = (selectedFilterValue, appliedFilterValue) => {
        return JSON.stringify(selectedFilterValue) === JSON.stringify(appliedFilterValue);
    };

    const areFiltersEqual = (currentSelectedFilters, currentAppliedFilters) => {
        if (currentSelectedFilters.length !== currentAppliedFilters.length) return false;
        for (let i = 0; i < currentSelectedFilters.length; i++) {
            if (!areFilterValuesEqual(currentSelectedFilters[i], currentAppliedFilters[i])) return false;
        }
        return true;
    };

    const closeModal = () => {
        setModal(false);
        setSelectedFilters(filters);
    }

    useLayoutEffect(() => {  // render inside 'collection-title-header' section
        const productCount = products?.total;
        if (productCountEl)
            productCountEl.textContent = productCount ? `${productCount} products` : ''

        if (contactButtonEl && handleOnClickContactSeller)
            render(<ContactButton handleOnClickContactSeller={handleOnClickContactSeller} />, contactButtonEl)

    }, [products, handleOnClickContactSeller])

    useEffect(() => {
        setIsApplyFilterBtnDisabled(areFiltersEqual(selectedFilters, filters));
    }, [selectedFilters, filters]);

    const updateSelectedFilters = (value) => {
        setSelectedFilters(() => {
            const existingIndex = selectedFilters.findIndex(filter => filter.value === value.value && value.field === filter.field);

            if (existingIndex !== -1) {
                const updatedFilters = [...selectedFilters];
                updatedFilters.splice(existingIndex, 1);
                return updatedFilters;
            } else return [...selectedFilters, value];

        });
    };

    const FilterIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <g id="Adjustments">
                    <path id="Icon" d="M10.75 4.99999V3.33333M10.75 4.99999C9.8295 4.99999 9.08331 5.74619 9.08331 6.66666C9.08331 7.58714 9.8295 8.33333 10.75 8.33333M10.75 4.99999C11.6705 4.99999 12.4166 5.74619 12.4166 6.66666C12.4166 7.58714 11.6705 8.33333 10.75 8.33333M5.74998 15C6.67045 15 7.41665 14.2538 7.41665 13.3333C7.41665 12.4129 6.67045 11.6667 5.74998 11.6667M5.74998 15C4.82951 15 4.08331 14.2538 4.08331 13.3333C4.08331 12.4129 4.82951 11.6667 5.74998 11.6667M5.74998 15V16.6667M5.74998 11.6667V3.33333M10.75 8.33333V16.6667M15.75 15C16.6705 15 17.4166 14.2538 17.4166 13.3333C17.4166 12.4129 16.6705 11.6667 15.75 11.6667M15.75 15C14.8295 15 14.0833 14.2538 14.0833 13.3333C14.0833 12.4129 14.8295 11.6667 15.75 11.6667M15.75 15V16.6667M15.75 11.6667V3.33333" stroke="#707073" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </svg>
        )
    }

    const updateProductSearch = (filters) => {
        updateSearch({
            products: {
                filter: mapFilters(filters),
            },
        })
    }

    // This is used for preparing schema needed for apply filters functinality.
    const mapFilters = (filters) => {
        const mappedFilters = {};

        filters.forEach(filter => {
            const field = filter.field;

            if (field === 'price' && filter.filter && filter.filter.range) {
                // Handle the price field differently
                if (!mappedFilters[field]) {
                    mappedFilters[field] = { field, range: [] };
                }

                filter.filter.range.forEach(rangeItem => {
                    mappedFilters[field].range.push(rangeItem);
                });
            } else {
                const value = filter.value;

                if (!mappedFilters[field]) {
                    mappedFilters[field] = { field, value: new Set() };
                }

                mappedFilters[field].value.add(value);
            }
        });

        // Convert sets to arrays
        Object.values(mappedFilters).forEach(filter => {
            if (filter.value) {
                filter.value = [...filter.value];
            }
        });

        return Object.values(mappedFilters);
    };


    const searchFilters = (value) => {
        if (value) {
            const existingIndex = selectedFilters.findIndex(filter => filter.value === value.value);
            let preferredFilter

            if (existingIndex === -1) preferredFilter = [...selectedFilters, value]
            else {
                const updatedFilters = [...selectedFilters];
                updatedFilters.splice(existingIndex, 1);
                preferredFilter = updatedFilters;
            }
            updateProductSearch(preferredFilter)
        }
    };

    const handleProductTypeFilterUpdate = (selectedFilter = "", mobileView = false) => {
        if (previousAppliedTypeFilter === selectedFilter) return;
        let updatedFilters = selectedFilters
        if (!selectedFilter) updatedFilters = selectedFilters.filter(({ name }) => name !== TYPE);
        else if (previousAppliedTypeFilter) updatedFilters = selectedFilters.map((filter) => filter.name !== TYPE ? filter : { name: TYPE, field: productTypeFilter.field, value: selectedFilter });
        else updatedFilters = [...selectedFilters, { name: TYPE, field: productTypeFilter.field, value: selectedFilter }]
        mobileView ? setSelectedFilters(updatedFilters) : updateProductSearch(updatedFilters)
    }

    if (!(filteredFacets?.length > 0)) return null;

    return (

        <div class={shouldShowNewSearch ? '' : "sec-sidebar"}>
            {/* desktop view */}
            <div className={`sticky-margin flex flex-row justify-between hidden lg:flex ${showProductFilterOnCollection ? 'flex-col-reverse gap-4' : ''}`}>
                <form class={formClass}>
                    {shouldShowNewSearch &&
                        <div class='bold-text mr-2'>Filter by</div>
                    }
                    {filteredFacets?.map((facet) => {
                        if (facet.name.includes('hidden')) return null; // Skip hidden ones
                        switch (facet.type) {
                            case 'terms':
                                return <Facet facet={facet} searchFilters={searchFilters} />
                            case 'stats':
                                return <RangeFacet facet={facet} />
                            default:
                                return null;
                        }
                    })}
                    {filters.length > 0 && shouldShowNewSearch &&
                        <button
                            class="plp-filters-remove-all link text-teal"
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Clear
                        </button>
                    }
                </form>
                <div class={`${showProductFilterOnCollection ? "flex justify-between" : ""}`}>
                    <ProductTypeFilter
                        updateProductSearch={updateProductSearch}
                        selectedFilters={selectedFilters}
                        searchQuery={query}
                        updatedTypeFilters={updatedTypeFilters}
                        productTypeFilter={productTypeFilter}
                        handleProductTypeFilterUpdate={handleProductTypeFilterUpdate}
                        showProductFilterOnCollection={showProductFilterOnCollection}
                    />
                    <div class='flex gap-4'>
                        <Sorting onlyForm shouldShowNewSearch sortByEl={sortByEl} />
                        {handleOnClickContactSeller && !contactButtonEl && <ContactButton handleOnClickContactSeller={handleOnClickContactSeller} />}
                    </div>
                </div>
            </div>
            {/* mobile view buttons*/}
            {shouldShowNewSearch && <div className='sticky-margin mobile-filter-container gap-8 lg:hidden'>
                <button onClick={() => setModal(true)} className='bg-white text-sm text-gray-700 hover:bg-gray-50 py-2 sm:px-3 flex-1 rounded-md border border-gray-300 flex gap-2 items-center justify-center'>
                    <FilterIcon />
                    <span>Filter</span>
                    {filters.length > 0 &&
                        <div class='bg-gray-300 text-black py-1 px-3 rounded-sm border-gray-200' >
                            {filters.length}
                        </div>}
                </button>
                <Sorting onlyForm shouldShowNewSearch />
            </div>}

            {/* mobile view filters */}
            {
                modal && (
                    <div className='modal-container'>
                        <div className='modal-header'>
                            <h4 className='text-lg font-bold text-gray-900'>Filters</h4>
                            <div className='mr-4' onClick={() => closeModal()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M6 18L18 6M6 6L18 18" stroke="#909092" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>

                        <form class={'filter-form modal-filter-form'}>
                            {showProductFilterOnCollection && (
                                <div class="flex product-type-toggle-filter rounded-lg mt-4 mobile-view">
                                    {PRODUCT_TYPE_FILTERS.map(({ label, value }) => (
                                        <button key={value}
                                            type="button"
                                            disabled={value && !updatedTypeFilters?.some((filter) => filter.value === value)}
                                            class={`py-1 px-7 rounded-lg duration-300 flex-1 toggle-value ${previousAppliedTypeFilter === value ? "selected-toggle" : ""}`}
                                            onClick={() => { handleProductTypeFilterUpdate(value, true) }}>
                                            {label}
                                        </button>
                                    ))}
                                </div>
                            )}
                            {filteredFacets?.map((facet) => {
                                if (facet.name.includes('hidden')) return null; // Skip hidden ones
                                switch (facet.type) {
                                    case 'terms':
                                        return <Facet facet={facet} isCategorySelected={true} searchFilters={searchFilters} updateSelectedFilters={updateSelectedFilters} selectedFilters={selectedFilters} />
                                    case 'stats':
                                        return <RangeFacet facet={facet} isCategorySelected={true} />
                                    default:
                                        return null;
                                }
                            })}
                        </form>
                        <div className='flex bg-white w-full fixed bottom-0 z-10 justify-between gap-4 border-t border-gray-100 border-t-2 p-4'>
                            <button className='bg-gray-100 text-sm text-gray-700 rounded-md py-2 px-4' onClick={() => closeModal()}>Cancel</button>
                            {filters.length > 0 && shouldShowNewSearch &&
                                <button
                                    className='mr-2'
                                    onClick={() => {
                                        removeAll()
                                    }}
                                >
                                    Clear
                                </button>
                            }
                            <button className={`mr-2 lg:hidden apply-btn ${isApplyFilterBtnDisabled && 'opacity-50'}`} disabled={isApplyFilterBtnDisabled} onClick={() => updateProductSearch(selectedFilters)}>Apply Filters</button>
                        </div>
                    </div>
                )
            }
        </div>
    )
}
